// extracted by mini-css-extract-plugin
export default {"btnpwd":"_17c8ff1c15"};